module.exports = __webpack_public_path__ + "static/img/qiaoliang.7edf4d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cases/qiaoliang.png
// module id = b9sK
// module chunks = 1